module.exports = __webpack_public_path__ + "img/arrow-back.a962e882.svg";